import { Button, FormItem, Modal, TextArea } from 'elmo-elements';
import React from 'react';
import type { TDeleteModalProps } from 'src/types';
import { StyledAlert } from './styles';
import { useModalState } from './hooks';

export const DeleteModal = ({ onClose, id }: TDeleteModalProps) => {
    const { isDeleting, onDeleteClick, serverErrors, setServerErrors, setMessage } =
        useModalState(id);

    return (
        <Modal
            id="delete-booking-modal"
            title="Confirmation of deleting"
            type="medium"
            isOpened
            closeModal={onClose}
            primaryButton={
                <Button
                    id="delete-button"
                    ariaLabel="save-booking"
                    type="primary"
                    isLoading={isDeleting}
                    isDisabled={isDeleting}
                    onClick={onDeleteClick}
                >
                    Delete
                </Button>
            }
        >
            {!!serverErrors.length && (
                <StyledAlert
                    id="booking-error"
                    aria-label="errors alert"
                    role="alert"
                    type="danger"
                    className="mb-4"
                    onClose={() => {
                        setServerErrors([]);
                    }}
                >
                    {serverErrors.join(', ')}
                </StyledAlert>
            )}

            <FormItem label="Message">
                <TextArea
                    id="delete-message"
                    name="message"
                    onChange={(e) => {
                        const { value } = e.target as HTMLTextAreaElement;
                        setMessage(value);
                    }}
                />
            </FormItem>
        </Modal>
    );
};
